import React, {useState, useEffect, Fragment} from 'react'

const CatalogueBrandSearchDatalist = ({list, filter}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(filter)
  }, [filter]);

  const handleSearchChange = event => {
    const {value} = event.target;

    if (value.length > 1) {
      const newOptions = list
        .filter(brand => brand.toLowerCase().indexOf(value.toLowerCase()) > -1)
        .map(brand => <option value={brand} key={brand}/>);

      setOptions(newOptions)
    }

    setInputValue(value)
  };

  return (
    <Fragment>
      <input type="search"
             className="brand-search"
             id="brand-search"
             placeholder="Поиск"
             list="brands"
             autoComplete="off"
             value={inputValue}
             onChange={handleSearchChange}/>
      <datalist id="brands">
        {options}
      </datalist>
    </Fragment>
  )
};

export default CatalogueBrandSearchDatalist
